"use strict";

import Page from "./Event.jsx";

export const auth = true;
export const title = "i18n:event.pageTitle";
export const Component = Page;
